import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import general from "../../assets/img/general-podiatry.jpg";

/**
 * General Podiatry detail page component
 */
const GeneralPodiatryDetail = () => {
  return (
    <ServiceDetailLayout
      title="General Podiatry"
      description="Professional general podiatry services including treatment of corns, callous, ingrown toenails & a toenail cutting service at The Moffat Foot Clinic."
      image={general}
      imageAlt="General Podiatry Treatment"
    >
      <h1 className="gs-u-mb+">General Podiatry</h1>
      <p className="text--large gs-u-mb++">
        Maintaining the health of your feet is crucial for the overall
        well-being of your body. Unhealthy feet can lead to difficulties in
        moving, limit your ability to exercise, and over time, make your life
        more challenging and uncomfortable.
      </p>

      <p className="gs-u-mb+">
        A typical visit to a podiatrist typically takes about 30 minutes.
      </p>

      <p className="gs-u-mb++">
        We provide treatment and guidance for the following common foot issues:
        Corns and Calluses, Athlete's Foot, Blisters, Chilblains, Excessive
        Sweating Feet, Nail problems such as thick, fungal, or ingrown toenails,
        and sores and ulcers. We frequently deal with verruca's, which are viral
        skin infections.
      </p>

      <p className="gs-u-mb++">
        While we recommend self-care, we also provide a range of topical
        solutions and cryosurgery. We treat many other foot conditions. If your
        issue isn't mentioned, feel free to ask the podiatrist. Additionally, we
        offer home visits as part of our services.
      </p>

      <h2 className="gs-u-mb+">Expert Care</h2>
      <p className="gs-u-mb++">
        Podiatrists have the expertise to evaluate, identify, and manage various
        issues affecting the feet and ankles, such as injuries, infections,
        abnormalities, and diseases. They also offer measures to prevent
        problems and educate patients on how to maintain healthy feet and a good
        quality of life.
      </p>

      <h2 className="gs-u-mb+">Frequently Seen Conditions</h2>
      <ul className="gs-u-mb++ benefits-list">
        <li>Toenail cutting</li>
        <li>Corns and callus removal</li>
        <li>Ingrown toenails</li>
        <li>Verruca treatment</li>
        <li>Diabetic foot care</li>
        <li>Fungal nails</li>
        <li>Bunions</li>
      </ul>

      <h2 className="gs-u-mb+">Modern Treatment Approach</h2>
      <p className="gs-u-mb+">
        At The Moffat Foot Clinic, we take care of your feet with the latest
        technology and modern podiatric methods to bring your feet back to
        optimal health. We offer home visits as part of our services.
      </p>
      <p className="gs-u-mb++">
        Your specific treatment plan will depend on your individual needs and
        goals.
      </p>
    </ServiceDetailLayout>
  );
};

export default GeneralPodiatryDetail;
